<div *ngIf="Hidden == true">
	<button class="btn btn-primary" style="padding: 0px 6px; opacity: 0.5; font-size: 20px" (click)="onHide()">
		<i class="fa fa-question" aria-hidden="true"></i>
	</button>
</div>
<div *ngIf="Hidden == false">
	<div class="CollapsedDiv" *ngIf="Expanded == false">
		<button class="btn btn-primary" style="padding: 6px 1px 6px 0px; border-radius: 0px; border-right: 1px solid white" (click)="onHide()">
			<i class="fa fa-chevron-down" aria-hidden="true"></i>
		</button>
		<button class="btn btn-primary" style="border-radius: 0px" (click)="onExpand()">Need Help?</button>
	</div>

	<div class="ExpandedDiv" *ngIf="Expanded == true">
		<div id="ChatMainDiv" class="ChatMainDiv">
			<div #ChatBackground id="ChatBackground" class="ChatBackground">
				<div
					*ngFor="let msg of lstMessages"
					[ngClass]="{
						MsgDiv: true,
						ErrorMsgDiv: msg.MessageTypeID == -1,
						SystemMsgDiv: msg.MessageTypeID == 0,
						UserMsgDiv: msg.MessageTypeID == 1,
						SupportMsgDiv: msg.MessageTypeID > 1
					}"
				>
					<p style="margin: 0px 0px 0px 5px">{{ msg.MessageText }}</p>
					<p *ngIf="msg.MessageTypeID != 0" style="margin: 0px 5px 0px 0px; text-align: right">{{ FormatDate(msg.c_date) }}</p>
				</div>
				<div *ngIf="LoadingMessages == true" class="LoadingMsgDiv">...Loading</div>
			</div>
			<div class="NextMessageGrid">
				<input class="NoRadius" type="text" [(ngModel)]="NextMessage" />
				<button class="btn btn-primary NoRadius" (click)="onSend()"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
			</div>
		</div>
		<button class="btn btn-primary" style="margin-bottom: 5px" (click)="onClear()">Clear Messages</button>
		<button class="btn btn-primary" style="margin-bottom: 5px" (click)="onContactSupport()">Contact Support</button>
		<button class="btn btn-warning" (click)="onExpand()">Cancel</button>
	</div>
</div>
